import { useEffect } from 'react'

import { useExperimentsContext } from '../components/ExperimentsContext'
import { useGetExperimentForTenant } from '../hooks'
import { EXPERIMENT_NAME_REMOVE_PACKSIZES_FOR_EXPA } from '../model/EXPERIMENT_NAME_PER_TENANT'

import { useRemovePackagesForExpaExperimentIsExpaPresentInUrl } from './components/useIsExpaPresentInUrl'

export const useRemovePacksizesExperimentActivation = (): void => {
  const removePackSizesExperiment = useGetExperimentForTenant(
    EXPERIMENT_NAME_REMOVE_PACKSIZES_FOR_EXPA,
  )
  const { addExperimentKeysForActivation } = useExperimentsContext()
  const isExpaPresentInUrl =
    useRemovePackagesForExpaExperimentIsExpaPresentInUrl()

  useEffect(() => {
    if (removePackSizesExperiment.isEnabled && isExpaPresentInUrl) {
      addExperimentKeysForActivation(removePackSizesExperiment.name)
    }
  }, [
    addExperimentKeysForActivation,
    removePackSizesExperiment.isEnabled,
    removePackSizesExperiment.name,
    isExpaPresentInUrl,
  ])
}
